import $ from 'jquery';

class AdjusterDeploy {

  constructor() {}

  init() {
    this.$config = document.getElementById('adjuster-deploy-config');

    if(!this.$config) return;

    this.data_scope = this.$config.getAttribute('data-selected-items-scope-id');
    this.selected_items_field_name = this.$config.getAttribute('data-selected-items-field-name') + '[]';
    this.selected_items_count_label_id = '#' + this.$config.getAttribute('data-selected-items-count-label-id');

    this.$modal = document.getElementById(this.$config.getAttribute('data-modal-id'));
    this.$modal_trigger_button = document.getElementById(this.$config.getAttribute('data-modal-trigger-id'));
    this.$selected_items_container = this.$modal.querySelector('#' + this.$config.getAttribute('data-selected-items-container-id'));

    this.refreshModalButtonStatus();
  }

  setupEvents() {

    if(!this.$config) return;

    let _this = this;

    $(this.$modal).on('shown.bs.modal', function () {

      let $checkedItems = Array.from(document.querySelectorAll('input[type="checkbox"]:not(.select-all)[data-scope="' + _this.data_scope + '"]'))
        .filter(node => node.checked);
      _this.$modal.querySelector(_this.selected_items_count_label_id).innerText = $checkedItems.length;
      _this.$selected_items_container.innerHTML = '';

      $checkedItems.forEach(function (node) {
        let input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', _this.selected_items_field_name);
        input.value = node.value;
        _this.$selected_items_container.appendChild(input);
      });

    });

    document.querySelectorAll('input[type="checkbox"][data-scope="' + _this.data_scope + '"]')
      .forEach(node => {
        node.addEventListener('click', function (event) {
          event.stopPropagation();
          _this.refreshModalButtonStatus();
        });
        node.parentNode.querySelector('label').addEventListener('click', function (event) {
          event.stopPropagation();
          _this.refreshModalButtonStatus();
        });
      });
  }

  refreshModalButtonStatus() {

    if(!this.$modal_trigger_button) return;

    let hasItems = Array.from(document.querySelectorAll('input[type="checkbox"]:not(.select-all)[data-scope="' + this.data_scope + '"]'))
      .filter(node => node.checked)
      .length > 0;

    this.$modal_trigger_button.disabled = !hasItems;
    if(hasItems) {
      this.$modal_trigger_button.classList.remove('disabled');
    } else {
      this.$modal_trigger_button.classList.add('disabled');
    }
  }

  load() {
    this.init();
    this.setupEvents();
  }
}

export default new AdjusterDeploy();
